// Extension functions for vanilla JS objects
export { }

declare global {
    interface Array<T> {
        /**
         * Returns first element of an array
         */
        first(): T

        /**
         * Returns last element of an array
         */
        last(): T

        /**
         * Removes element of an array defined by the predicate
         */
        remove(predicate: (value: T) => unknown): boolean
    }
    interface Math {
        isLatitude(lat: number): boolean
        isLongitude(lng: number): boolean
        avg(arr: number[]): number
        roundUpToHundred(num: number): number
    }

    interface Date {
        toISODateString(): string
    }

    interface String {
        capitalizeFirstLetter(): string
        capitalizeWords(): string
        IsTruthy(): boolean
    }
}

export class UID {
    /**
     * Returns unique ID
     */
    static create(): number {
        const array = new Uint32Array(1)
        window.crypto.getRandomValues(array)
        return array[0]
    }
}


Array.prototype.first = function () {
    return this.length > 0 ? this[0] : undefined
}

Array.prototype.last = function () {
    return this.length > 0 ? this[this.length - 1] : undefined
}

Array.prototype.remove = function <T>(predicate: (value: T) => unknown) {
    const idx = this.findIndex(predicate)
    if (idx >= 0) {
        this.splice(idx, 1)
        return true
    }
    return false
}

Math.isLatitude = lat => {
    return isFinite(lat) && Math.abs(lat) <= 90
}

Math.isLongitude = lng => {
    return isFinite(lng) && Math.abs(lng) <= 180
}
Math.avg = (arr: number[]) => {
    let total = 0
    for (let i = 0; i < arr.length; i++) {
        total += arr[i]
    }
    return total / arr.length
}

Math.roundUpToHundred = (num: number) => {
    return Math.ceil(num / 100) * 100;
}

Date.prototype.toISODateString = function () {
    // Copying date to new object so that original doesn't get modified
    const date = new Date(this.getTime())
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset())
    return date.toISOString().slice(0, 10)
}

String.prototype.capitalizeFirstLetter = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
}

String.prototype.capitalizeWords = function () {
    return this.split(" ")
        .map(word => word.capitalizeFirstLetter())
        .join(" ");
}

String.prototype.IsTruthy = function () {
    if (this === 'true' || this === 'True' || this === '1') { return true }
    return false
}


